import { Box, Paper, TextField } from "@mui/material";
import { FilesGrid } from "../../Messages/components/FilesGrid";
import { LoadingIndicator } from "../../Messages/components/Composer/LoadingIndicator";
import { RecordingIndicator } from "../../Messages/components/Composer/RecordingIndicator";
import { SenderButtons } from "../../Messages/components/Composer/SenderButtons";
import { useContactCenterTheme } from "../../virtual-receptionist/theming/ContactCenterThemeContext";
import { MentionAutocomplete } from "./MentionAutocomplete";

export const GroupComposer = ({ composer }: { composer: any }) => {
  const { theme } = useContactCenterTheme();
  const {
    message,
    handleSend,
    isSendable,
    isRecording,
    startRecording,
    stopRecording,
    recordingTime,
    uploadingMessage,
    handleFileClick,
    handleImageClick,
    selectedFiles,
    selectedImages,
    handleRemoveFile,
    handleRemoveImage,
    inputRef,
    handleChange,
    handleKeyDown,
    insertMention,
    mentionSuggestions,
    mentionActiveIndex,
    isMentionOpen,
  } = composer;

  return (
    <Paper
      elevation={0}
      sx={{
        position: "relative",
        border: "1px solid",
        borderColor: theme.shell.border,
        borderRadius: 3,
        m: 1,
        overflow: "visible",
        flexShrink: 0,
        backgroundColor: theme.chat.inputBg,
        color: theme.shell.textPrimary,
      }}
    >
      {isMentionOpen && (
        <MentionAutocomplete members={mentionSuggestions} activeIndex={mentionActiveIndex} onSelect={insertMention} />
      )}

      {isRecording && <RecordingIndicator recordingTime={recordingTime} />}

      {(selectedFiles.length > 0 || selectedImages.length > 0) && (
        <FilesGrid
          selectedFiles={selectedFiles}
          selectedImages={selectedImages}
          onRemoveFile={handleRemoveFile}
          onRemoveImage={handleRemoveImage}
        />
      )}

      {uploadingMessage && <LoadingIndicator />}

      <Box px={1.5} pt={1}>
        <form onSubmit={handleSend} style={{ display: "flex", width: "100%" }}>
          <TextField
            inputRef={inputRef}
            value={message}
            onChange={handleChange}
            placeholder="Write a message... use @ to mention"
            variant="standard"
            multiline
            maxRows={4}
            fullWidth
            InputProps={{ disableUnderline: true }}
            onKeyDown={(event) => {
              if (handleKeyDown(event)) return;
              if (event.key === "Enter" && !event.shiftKey) {
                event.preventDefault();
                handleSend();
              }
            }}
            sx={{
              "& .MuiInputBase-root": {
                fontSize: { xs: 15, sm: 14 },
                color: theme.shell.textPrimary,
              },
            }}
          />
        </form>
      </Box>

      <SenderButtons
        canSend={isSendable}
        uploadingMessage={uploadingMessage}
        isRecording={isRecording}
        onStartRecording={startRecording}
        onStopRecording={stopRecording}
        onSend={handleSend}
        onFileClick={handleFileClick}
        onImageClick={handleImageClick}
      />
    </Paper>
  );
};
